module.exports = __webpack_public_path__ + "static/media/BSPLogoDark.79d9867e.png";